import type {GridColType} from "@mui/x-data-grid-premium";

export type BasicTypes =
    | 'number-currency'
    | 'string-supplier-id'

export type CustomTypes = string;

/**
 * Custom types similar to `GridColDef.type`
 *
 * Used to determine the non-JSON serializable parts of the GridColDef
 */
export type JSONSerializableColumnType<T extends CustomTypes = never> =
    GridColType
    | BasicTypes
    | `custom-${T}`

export function isCustomType<T extends CustomTypes = never>(serializableType: JSONSerializableColumnType<T>): serializableType is `custom-${T}` {
    return serializableType.startsWith('custom-')
}
